import wrapper from 'wrapper';

import PanelSlider from '../panel-slider/panel-slider';

function main() {
    const root = wrapper.select('#vjeastasia-448');
    new PanelSlider(root.querySelector('.panel-slider'));
    root.classList.remove('no-js');
    root.classList.add('js');
}

main();
